// src/components/common/ThemeToggle.tsx
import React from 'react';
import { IconButton, Tooltip, useTheme } from '@mui/material';
import { useCustomTheme } from '../../contexts/ThemeContext';

const ThemeToggle: React.FC = () => {
  const { mode, toggleTheme } = useCustomTheme();
  const theme = useTheme();

  return (
    <Tooltip title={`Switch to ${mode === 'light' ? 'dark' : 'light'} mode`}>
      <IconButton 
        onClick={toggleTheme}
        sx={{
          ml: 1,
          color: theme.palette.text.primary,
          '&:hover': {
            backgroundColor: theme.palette.action.hover,
            transform: 'rotate(180deg)',
            transition: 'all 0.3s ease-in-out',
          },
        }}
      >
        {mode === 'light' ? (
          <span style={{ fontSize: '1.2rem' }}>🌙</span>
        ) : (
          <span style={{ fontSize: '1.2rem' }}>☀️</span>
        )}
      </IconButton>
    </Tooltip>
  );
};

export default ThemeToggle;